import React from 'react';
import { useSelect } from 'downshift';

interface Props {
  items: string[];
  selected: string;
  onChange: (val: string) => void;
}

function TrackSelect({ items, selected, onChange }: Props) {
  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    selectedItem,
    getItemProps,
  } = useSelect({
    items,
    selectedItem: selected,
    onSelectedItemChange: (state) => {
      if (state.selectedItem !== undefined && state.selectedItem !== null) {
        onChange(state.selectedItem);
      }
    },
  });

  return (
    <div className="relative cursor-pointer">
      <div {...getToggleButtonProps()}>{selectedItem}</div>
      <div
        className="absolute bottom-50 -right-15 z-30 w-75 select-none overflow-hidden rounded bg-white text-base text-black focus:outline-none"
        {...getMenuProps()}
      >
        {isOpen &&
          items.map((item, index) => (
            <div
              className="flex h-30 cursor-pointer items-center justify-center px-10 hover:bg-white-light"
              key={item}
              {...getItemProps({
                item,
                index,
                onClick: (e) => {
                  e.stopPropagation();
                },
              })}
            >
              {item}
            </div>
          ))}
      </div>
    </div>
  );
}

export default TrackSelect;
